<script>
import {
  CdrModal,
  CdrText,
  CdrImg,
} from '@rei/cedar';

export default {
  name: 'GiftcardPreviewComponent',
  components: {
    CdrModal,
    CdrText,
    CdrImg,
  },
  props: {
    opened: {
      type: Boolean,
      required: true,
    },
    giftCard: {
      type: Object,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    from: {
      type: String,
      required: true,
    },
    amount: {
      type: String,
      default: null,
    },
    recepientEmail: {
      type: String,
      required: true,
    },
    confirmEmail: {
      type: String,
      required: true,
    },
    deliveryDate: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  emits: ['onCloseModal'],
  methods: {
    onCloseModal() {
      this.$emit('onCloseModal', false);
    },
  },
};
</script>
<template>
  <cdr-modal
    label="E-gift Card Preview"
    :opened="opened"
    aria-describedby="E-gift Card Preview"
    class="giftcard__modal"
    data-ui="gift-card-preview-modal"
    @closed="onCloseModal"
  >
    <template #title>
      <cdr-text
        tag="h3"
        class="giftcard__modal-title-header"
      >
        E-gift Card Preview
      </cdr-text>
    </template>
    <div class="giftcard__modal-main">
      <div class="giftcard__modal-left">
        <cdr-img
          :src="giftCard.mediaPath || ''"
          :alt="giftCard.description || ''"
          :data-media-code="`${giftCard.mediaCode}`"
          class="giftcard__modal-image"
          data-ui="gift-card-preview-image"
          loading="lazy"
        />
        <cdr-text
          tag="h1"
          class="giftcard__modal-title"
          data-ui="gift-card-preview-title"
        >
          HERE'S TO YOUR NEXT ADVENTURE
        </cdr-text>
        <cdr-text
          class="giftcard__modal-text"
          data-ui="gift-card-preview-description"
        >
          {{ `${to}, use this e-gift toward anything you want at REI.
            It's like you're a kid in a (huge, outdoorsy) candy store.` }}
        </cdr-text>
      </div>
      <div class="giftcard__modal-right">
        <div>
          <cdr-text
            class="giftcard__modal-label"
          >
            Amount:
          </cdr-text>
          <cdr-text
            class="giftcard__modal-amount"
            data-ui="gift-card-preview-amount"
          >
            ${{ amount }}
          </cdr-text>
        </div>
        <div>
          <cdr-text
            class="giftcard__modal-label"
          >
            To:
          </cdr-text>
          <cdr-text
            class="giftcard__modal-text"
            data-ui="gift-card-preview-to"
          >
            {{ to }}
          </cdr-text>
        </div>
        <div>
          <cdr-text
            class="gift-card__modal-label"
          >
            From:
          </cdr-text>
          <cdr-text
            class="giftcard__modal-text"
            data-ui="gift-card-preview-from"
          >
            {{ from }}
          </cdr-text>
        </div>
        <div v-if="message !== '' || message">
          <cdr-text
            class="giftcard__modal-label"
          >
            Message:
          </cdr-text>
          <cdr-text
            class="giftcard__modal-text"
            data-ui="gift-card-preview-message"
          >
            {{ message }}
          </cdr-text>
        </div>
        <div class="giftcard__modal-footer">
          <div class="giftcard__modal-container-card">
            <cdr-text class="giftcard__modal-footer-label">
              E-Gift Card #:
            </cdr-text>
            <cdr-img
              src="/assets/gift-card/preview-card-number/live.jpg"
              alt="preview-card-num"
              class="giftcard__modal-card"
              loading="lazy"
            />
          </div>
          <div class="giftcard__modal-container-pin">
            <cdr-text class="giftcard__modal-footer-label">
              PIN:
            </cdr-text>
            <cdr-img
              src="/assets/gift-card/preview-pin/live.jpg"
              alt="preview-card-num"
              class="giftcard__modal-pin"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  </cdr-modal>
</template>
